<script setup lang="ts">
import {useConfig} from '@/composables/config'

const config = useConfig()

defineProps<{
  title?: string
  height: string
  card?: boolean
  type?: string
}>()
</script>

<template>
  <div
      :card="card"
      class="footer-block--map"
      :title="title"
  >
    <iframe
        v-if="!type"
        :src="config.map.iframe"
        allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
    />
    <v-card v-else-if="type === 'maplibre'" :elevation="0">
      <MapLibre
          :options="config.map.options"
          :markers="config.map.markers"
          :height="height"
      />
    </v-card>
  </div>
</template>

<style scoped lang="scss">
.footer-block--map {
  iframe {
    border: 0;
    width: 100%;
    height: v-bind(height);
  }
}
</style>